<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="600"
    >
      <el-table-column
        prop="corp_user_name"
        label="员工姓名"
        width="200"
        align="center"
      />
      <el-table-column
        prop="corp_name"
        label="公司名称"
        width="330"
        align="center"
      />
      <el-table-column
        prop="corp_user_disable_status"
        label="状态"
        width="180"
        align="center"
      />
      <el-table-column
        prop="corp_user_login_status"
        label="登录状态"
        width="180"
        align="center"
      />
      <el-table-column
        prop="corp_user_login_status"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="unband(scope.row.client_host,scope.row.employee_no)">解绑</el-button>
          <el-button type="warning" size="mini" @click="lookinfo(scope.row.corp_id,scope.row.employee_no)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { upToolclientRelation, upToolunbind } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      client_host: '',
      tableData: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(client_host) {
      this.client_host = client_host
      this.list()
      console.log(client_host)
    },
    async list() {
      const data = await upToolclientRelation({
        client_host: this.client_host
      })
      this.tableData = data.data
      console.log('data', data)
    },
    unband(client_host, employee_no) {
      this.$confirm('此操作将解绑, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        upToolunbind({
          client_host: client_host,
          employee_no: employee_no
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
          this.list()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑'
        })
      })
    },
    lookinfo(corp_id, employee_no) {
      this.$emit('closer')
      this.$router.push({ name: 'EnterpriseAstaff', params: { corp_id: corp_id, employee_no: employee_no }})
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
